import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchChildUsers } from 'actions/users';
import UserDrawer from 'components/users/child-users/drawer';
import UserTable from 'components/users/child-users/table';
import Pagination from 'components/pagination';
import {
  HeaderFlexRow,
  Container,
  PlainButton,
  HeadingTitle,
} from 'components/styled-components';
import { Section } from 'containers/Manage-Questionnaire/styled-components';
import Controls from 'components/users/controls';
import Loading from 'components/loading';
import { Intent } from '@blueprintjs/core';
import { AppToaster } from 'components/AppToaster';
import { createUser } from 'api/users';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';

class ManageChildUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      currentPage: 0,
      perPage: 10,
      query: '',
    };
  }
  componentDidMount() {
    this.props.fetchChildUsers({
      start: this.state.currentPage,
      limit: this.state.perPage,
      thirdParty: this.props.appUser.thirdParty,
    });
  }

  handlePageClick = currentPage => {
    this.setState({ currentPage }, () =>
      this.props.fetchChildUsers({
        limit: this.state.perPage,
        start: this.state.currentPage * this.state.perPage,
        query: this.state.query,
      })
    );
  };

  handlePerPageChange = perPage => {
    this.setState({ perPage: perPage.value, currentPage: 0 }, () =>
      this.props.fetchChildUsers({
        limit: this.state.perPage,
        start: this.state.currentPage * this.state.perPage,
        query: this.state.query,
      })
    );
  };

  handleSearch = query => {
    this.setState({ query, currentPage: 0 }, () => {
      this.props.fetchChildUsers({
        limit: this.state.perPage,
        start: 0,
        query,
      });
    });
  };

  handleAddUserClick = () => {
    this.setState({ isOpen: true });
  };

  handleCloseDrawer = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleSaveUser = (user, actions) => {
    const userWithThirdParty = {
      ...user,
      role: { roleName: 'THIRD_PARTY' },
    };
    createUser(userWithThirdParty)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);
        this.props.fetchChildUsers({
          limit: this.state.perPage,
          start: this.state.currentPage * this.state.perPage,
          thirdParty: this.props.appUser.thirdParty,
        });
        this.handleCloseDrawer();
      })
      .catch(err => {
        actions.setSubmitting(false);
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  render() {
    const { users, isFetching } = this.props;
	const { thirdPartyIDs, thirdPartyNames } = this.props.appUser;
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>User Management</HeadingTitle>
          {hasPermission(this.props.appUser.permissions, [
            Permissions.CREATE_ALL_USERS,
            Permissions.CREATE_THIRD_PARTY_USER_FOR_THIRD_PARTY,
          ]) && (
            <PlainButton onClick={this.handleAddUserClick}>
              ADD USER
            </PlainButton>
          )}
        </HeaderFlexRow>
        <Controls handleSearch={this.handleSearch} />
        <Section>
          {isFetching && <Loading size={100} />}
          {users && !isFetching && <UserTable users={users.result} />}
        </Section>
        <UserDrawer
          isOpen={this.state.isOpen}
          handleCloseDrawer={this.handleCloseDrawer}
          handleTextChange={this.handleTextChange}
          handleSaveUser={this.handleSaveUser}
          departments={this.props.departments}
		  vendors={thirdPartyIDs.map((tpi, key) => { return { vendorID: tpi, vendorName: thirdPartyNames[key] } })}
        />

        <Pagination
          numRecords={users.totalCount}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users.vendorUsers,
  vendors: state.vendorRequest.vendors,
  isFetching: state.users.isUsersFetching,
  errorMessage: state.users.errorMessageUsers,
});

ManageChildUsers = connect(
  mapStateToProps,
  {
    fetchChildUsers,
  }
)(ManageChildUsers);

export default ManageChildUsers;
